module.exports = __webpack_public_path__ + "static/media/intro2.085f3ff6.png";